// extracted by mini-css-extract-plugin
export var stepActive = "_2d-3";
export var stepCompleted = "_2d-4";
export var stepConnectorLine = "_2d-b";
export var stepIndicatorCircle = "_2d-6";
export var stepIndicatorCircleCompleted = "_2d-7";
export var stepIndicatorCircleDefault = "_2d-8";
export var stepIndicatorTextCompleted = "_2d-9";
export var stepIndicatorTextDefault = "_2d-a";
export var stepPending = "_2d-5";
export var wizardContainer = "_2d-1";
export var wizardContent = "_2d-2";
export var wizardModal = "_2d-0";